const en = {
  nav: {
    home: 'Home',
    about: 'About',
    resume: 'Resume',
    principle: 'Working Principle',
    contact: 'Contact',
  },
  hero: {
    firstName: 'Murat',
    lastName: 'Selcukoglu',
    greeting: "Hi, I'm",
    occupation: 'Mobile Frontend Developer',
    from: 'based in',
    description:
      "Let's take a look at what I do — welcome to my corner of the web.",
    cta: 'More about me',
    download: 'Download Resume',
    scroll: 'Scroll down',
  },
  about: {
    title: 'About Me',
    bio: "My name is Murat. I'm a Mobile Frontend Developer with over four years of experience building mobile and web applications with React Native and React (Next.js). I specialize in creating scalable, high-performance user interfaces, integrating RESTful APIs, and delivering end-to-end release cycles for both the App Store and Google Play — including deployment, updates, and performance optimization. I focus on writing clean, human-readable code and crafting interfaces that balance beautiful design with accessibility for all.",
    contactDetails: 'Contact Details',
    downloadResume: 'Download Resume',
    location: 'Location',
    email: 'Email',
    phone: 'Phone',
  },
  resume: {
    educationTitle: 'Education',
    workTitle: 'Experience',
    skillsTitle: 'Skills',
    skillMessage:
      'React Native and React.js are my primary front-end stack, complemented by deep JavaScript expertise. I have a strong track record of publishing iOS and Android applications, owning the full development lifecycle from idea to production release.',
    present: 'Present',
    education: [
      {
        school: 'National Defence University — Ankara, Turkey',
        degree: 'B.Sc. Systems Engineering',
        graduated: '2009 – 2013',
        description:
          'Bachelor of Science in Systems Engineering with a focus on system engineering, software development, IT systems, and system architectures. Recognized by the German ZAB (Central Office for Foreign Education) as equivalent to a German bachelor-level degree.',
      },
    ],
    work: [
      {
        slug: 'akinon',
        company: 'Akinon',
        title: 'Mobile Frontend Developer',
        years: 'June 2023 – August 2025',
        description:
          'I worked as a React Native Developer specializing in e-commerce applications for prominent retail brands. I led the development and launch of the Lacoste app in Turkey — the first of its kind worldwide — and contributed to the Lulu Supermarket app, which is highly popular across the Arab region. I also played an active role in implementing apps for brands such as Marks & Spencer, GAP, Koton, Intersport, and Forever21, and helped maintain many other retail apps within the company. These projects strengthened my abilities in building user-friendly interfaces, ensuring robust performance, and collaborating effectively in cross-functional teams.',
      },
      {
        slug: 'cyberkoc',
        company: 'CyberKOC (Freelance)',
        title: 'Mobile Frontend Developer',
        years: 'March 2024 – August 2025',
        description:
          'Developed "Al Moheet", a mobile book-reading application built with React Native for a publishing house. I owned the App Store and Google Play release processes, including deployment, updates, and maintenance. My responsibilities covered performance optimization, implementing new features, and delivering a smooth, consistent user experience across both platforms.',
      },
      {
        slug: 'yapisepeti',
        company: 'Yapı Sepeti (Freelance)',
        title: 'React Native Developer',
        years: 'March 2023 – July 2023',
        description:
          'Contributed to the development of the Yapı Sepeti mobile application with React Native. I was responsible for implementing user interfaces, integrating APIs, developing new features, and optimizing existing ones — as well as analyzing and fixing technical issues to improve the stability and performance of the app.',
      },
      {
        slug: 'mobrespos',
        company: 'Mobrespos Software',
        title: 'Mobile Frontend Developer',
        years: 'April 2021 – June 2023',
        description:
          'For over two years, I worked on the development and enhancement of mobile applications with React Native, covering the full development cycle from concept through implementation and testing to release and maintenance. I built user-friendly mobile apps for restaurant and digital ordering systems, applying modern UI/UX concepts for an optimal user experience. In addition, I developed and maintained React-based web applications, integrated backend services via RESTful APIs, and worked on new features, process improvements, and the performance and stability of the apps across platforms.',
      },
      {
        slug: 'msb',
        company: 'MSB (Ministry of National Defence)',
        title: 'System Engineer',
        years: 'August 2013 – April 2021',
        description:
          'As a System Engineer, I was responsible for the analysis, planning, implementation, and further development of technical systems for several years. I gained extensive experience managing complex IT and communication infrastructures — including the installation, configuration, and maintenance of hardware and software systems, conducting system analyses, and identifying and resolving technical issues. I also worked on optimizing existing system architectures, improving system stability, planning and executing technical projects, and creating technical documentation in collaboration with different departments.',
      },
    ],
  },
  testimonials: {
    title: 'Working Principle',
    subtitle: 'What drives me',
    items: [
      {
        text: "I'm a seasoned software developer with extensive experience designing and developing robust software solutions. My skill set includes strong problem-solving and a thorough approach to testing. Throughout my career I have consistently delivered high-quality software by combining technical expertise with attention to detail. I thrive in dynamic environments, tackling complex challenges with efficiency and precision.",
        user: 'Murat SELCUKOGLU',
        role: 'Developer Philosophy',
      },
      {
        text: 'I believe in maintainable code — simple, readable, and stripped down to what matters. Shipping fast is great, but what matters long-term is the code the team still understands six months from now. That is why I invest time in architecture, code reviews, and automated tests.',
        user: 'Murat SELCUKOGLU',
        role: 'Code Quality',
      },
      {
        text: 'Performance is not a bonus — it is part of the user experience. From bundle-size tuning and render optimization to native modules, I measure, analyze, and optimize continuously so the app does not just work, but feels smooth.',
        user: 'Murat SELCUKOGLU',
        role: 'Performance & UX',
      },
    ],
  },
  contact: {
    title: 'Get In Touch',
    lead: 'Have a project in mind or just want to say hello? Drop me a message and I will get back to you as soon as I can.',
    name: 'Name',
    email: 'Email',
    subject: 'Subject',
    message: 'Message',
    submit: 'Send Message',
    sending: 'Sending…',
    success: 'Your message was sent successfully. Thank you!',
    error: 'Something went wrong. Please try again.',
    required: 'Required',
    sidebarTitle: 'Address & Phone',
    available: 'Available for new projects',
  },
  footer: {
    rights: 'All rights reserved.',
    builtWith: 'Built with React & love by',
    backToTop: 'Back to top',
  },
};

export default en;
